module.exports = __webpack_public_path__ + "img/documentUpload.75cf0dff.svg";